import React from 'react';
import Layout from '../components/layout';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function IndexPage() {
  return React.createElement(Layout, null);
}

export default IndexPage;